// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print{.dispatch-summary-container{border:2px solid #000;border-radius:0.25em}}\n", ""]);
// Exports
module.exports = exports;
